import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import $ from "jquery";
import axios from "axios";
import Nav from "./Nav";
import pageTransition from "../utils/pageTransition";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: true,
      isLoggedIn: true,
      currentUser: "",
      table: false,
    };
  }

  componentDidMount() {
    let id = this.props.auth.user.id;
    axios.get("https://trend-backend.herokuapp.com/api/users/").then((res) => {
      console.log(res.data);
    });
    axios
      .get(`https://trend-backend.herokuapp.com/api/users/${id}/data`)
      .then((res) => {
        // axios.get(`http://localhost:3005/api/users/${id}/data`).then((res) => {
        var userData = res.data;
        delete userData["password"];
        this.setState({
          name: userData.name,
          created: userData.date,
          id: userData._id,
          stocks: [userData.stocks],
          cryptos: [userData.cryptos],
        });
      });
    var x = window.matchMedia("(max-width: 700px)");
    if (x.matches) {
      this.setState({ mobile: true });
    } else {
      this.setState({ mobile: false });
    }
  }
  showTable = () => {
    $(".loader-wrapper").css("display", "block");
    $(".loader-wrapper").fadeIn();
    setTimeout(() => {
      $(".loader-wrapper").fadeOut();
      setTimeout(() => {
        $(".m-container").fadeIn();
        $("body").css("overflow-y", "auto");
      }, 200);
    }, 3000);
    return this.setState({ table: true });
  };

  render() {
    return (
      <main>
        <Nav isLoggedIn={this.state.isLoggedIn} />
        <div className="main-container">
          <ul className="widgets-container">
            <div className="top">
              <li className="widget favs">
                <div className="fav-stocks-content">
                  <h3 className="title">My Stocks</h3>
                  <div className="axios-data"></div>
                </div>
              </li>
            </div>
            <div className="bottom">
              <li className="widget recent">
                <div className="recent-stocks-content">
                  <h3 className="title">Recently Viewed</h3>
                  <div className="axios-data"></div>
                </div>
              </li>
              <li className="widget reccomended">
                <div className="reccomended-stocks-content">
                  <h3 className="title">Reccomended</h3>
                  <div className="axios-data"></div>
                </div>
              </li>
            </div>
          </ul>
        </div>
      </main>
    );
  }
}

Dashboard.propTypes = {
  auth: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
});
export default connect(mapStateToProps, {})(Dashboard);
